import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { MfaRequiredOverlayComponent } from '@layouts/vertical-layout/mfa-required-overlay.component';

import { AiHelpComponent } from '@components/ai-help/ai-help.component';
import { FooterComponent } from '@components/footer/footer.component';
import { HeaderComponent } from '@components/header/header.component';

import { SessionTimeoutService } from '@services/helper/session-timeout.service';

@Component({
  selector: 'app-vertical-layout',
  imports: [
    RouterOutlet,
    FooterComponent,
    CommonModule,
    HeaderComponent,
    MfaRequiredOverlayComponent,
    AiHelpComponent,
  ],
  templateUrl: './vertical-layout.component.html',
  styleUrl: './vertical-layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VerticalLayoutComponent {
  constructor() {
    /**
     * Resolved purely to construct it — the result is deliberately unused.
     * `SessionTimeoutService` is `providedIn: 'root'`, so it does nothing until
     * something asks for it; the authenticated shell is the right place,
     * because the idle timer should run on every signed-in screen and never on
     * the public/auth pages.
     */
    inject(SessionTimeoutService);
  }
}
